<template>
  <v-expand-transition>
    <v-card
      :id="sectionElId(section)"
      style="margin-bottom:20px;border:1px rgba(0,0,0,0.1) solid;"
      v-if="showSection"
    >
      <v-toolbar
        dense
        flat
        color="rgba(0,0,0,0.09)"
        height="auto"
        style="padding-top:10px;padding-bottom:10px;"
      >
        <strong
          v-if="section.number"
          v-html="section.number + '.'"
        ></strong>
        &nbsp;
        <span
          class="inlineLimiter"
          v-html="section.text"
        ></span>
        <div
          v-if="hidden"
          style="color: rgba(0,0,0,0.4);font-weight: bold;"
        >
          &nbsp;&nbsp;&nbsp;--&nbsp;&nbsp;&nbsp;
          <span
            v-if="question_count > 0"
          >
            {{question_count}} questions
          </span>
          {{ question_count > 0 && section_count > 0 ? 'and' : ''}}
          <span
            v-if="section_count > 0"
          >
            {{section_count}} sections
          </span>
          hidden
        </div>
        <v-spacer />
        <v-icon
          v-if="section.tip_text"
          class="help_button"
          style="float: right;cursor: hand;"
          @click="tip_dialog=true"
        >
          mdi-help-circle
        </v-icon>
        <v-btn
          v-if="section.web_collapsible"
          roll="button"
          small
          flat
          class="section-edit-button"
          style="float:right;position:absolute;right:10px;top:0px;color: grey;"
          @click="hidden=!hidden"
        >
          <span>
            {{ hidden ? 'Show Section' : 'Hide Section'}}
          </span>
          <v-icon
            color="grey"
          >
            {{ hidden ? 'arrow_drop_down' : 'arrow_drop_up'}}
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text
        :style="hidden ? 'display:none;' : ''"
      >
        <UserFormPartList
          :parts="section.parts"
          :user-form-id="userFormId"
          :read-only="section.read_only || readOnly"
        />
      </v-card-text>
      <v-dialog
        v-model="tip_dialog"
        width="650"
      >
        <v-card>
          <v-toolbar
            flat
            dark
            dense
          >
            Section Details Tip
          </v-toolbar>
          <v-card-text>
            <div v-html="section.tip_text" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="tip_dialog=false"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-expand-transition>
</template>

<script>
import { mapGetters } from 'vuex'
import UserFormPartList from './UserFormPartList'
import GlobalConstants from '@/globals'

export default {
  name: 'UserFormSection',
  props: ['userFormId', 'section', 'readOnly'],
  data () {
    return {
      tip_dialog: false,
      hidden: false
    }
  },
  beforeCreate () {
    this.$options.components.UserFormPartList = UserFormPartList
  },
  methods: {
    sectionElId (section) {
      return `section-${section.id}`
    }
  },
  computed: {
    ...mapGetters('userform', [
      'answer',
      'parts'
    ]),
    showSection(){
      if (!this.checkPermission('userform', this.PERMISSIONS.CAN_EDIT) && this.checkPermission('userform', this.PERMISSIONS.CAN_CONTACT_EDIT))
        return GlobalConstants.MeetsCondition(this.section, this.answer, this.parts)
      return true
    },
    question_count () {      
      var questionCount = 0;
      this.section.parts.forEach((part) => {
        if (part.part_type == "q")
          questionCount++
      })
      return questionCount
    },
    section_count () { 
      var sectionCount = 0;
      this.section.parts.forEach((part) => {
        if (part.part_type == "s")
          sectionCount++
      })
      return sectionCount
    }
  },
  mounted () {
    if (window.location.hash === '#' + this.sectionElId(this.section)) {
      this.$vuetify.goTo(window.location.hash, { duration: 300, offset: 0, easing: 'easeInOutCubic' })
    }
  }
}
</script>

<style scoped>
.inlineLimiter >>> :first-child {
  display:inline;
}
.help_button:hover {
  color: #1976d2 !important;
}
</style>
